var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F72349"
    },
    d: "M163.701,342.127c-0.536,5.636-1.8,11.06-3.701,16.174c-5.484,14.749-16.25,26.922-30,34.234V460h30 v-60c29.4,0,54.152-19.831,61.655-46.841L163.701,342.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F72349"
    },
    d: "M350,460h30V353.288c-8.623,7.016-18.772,12.189-30,15.172V460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB5858"
    },
    d: "M360,190c0-16.569-13.432-30-30-30v40h30V190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF835D"
    },
    d: "M361.41,329.73c-9.27,7.69-21.21,11.68-34.47,11.68c-4.31,0-8.77-0.42-13.31-1.28l-23.63-4.5V460h30 v-88.851c10.574,0.749,20.661-0.209,30-2.689c11.228-2.982,21.377-8.156,30-15.172c18.52-15.07,30-38.643,30-67.288h-30 C380,304.26,373.4,319.79,361.41,329.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB071"
    },
    d: "M164,311.645V336c0,2.067-0.107,4.109-0.299,6.127l57.953,11.032L290,366.17v-30.54L164,311.645z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAE8AC"
    },
    points: "380,286 410,286 410,236.667 380,241.667  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F72349"
    },
    d: "M450,200h-40v-10c0-16.569-13.432-30-30-30v40h-50v60h-40v75.63l23.63,4.5 c4.54,0.86,9,1.28,13.31,1.28c13.26,0,25.2-3.99,34.47-11.68C373.4,319.79,380,304.26,380,286v-44.333l30-5L450,230V200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB5858"
    },
    d: "M100,260V96.657H19.992C13.516,115.203,10,135.151,10,155.908c0,66.633,36.198,124.797,90,155.92 V350H70v110h30v-60c10.843,0,21.051-2.706,30-7.465c13.75-7.312,24.516-19.485,30-34.234c1.902-5.115,3.166-10.538,3.701-16.174 c0.192-2.017,0.299-4.059,0.299-6.127v-24.355l126,23.985V260H100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAE8AC"
    },
    d: "M100,0C62.968,21.422,34.273,55.662,19.992,96.657H100V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ab59c9fdeaac49fb33386175e93920f.svg";
export { ForwardRef as ReactComponent };